import { Injectable } from "@angular/core";
import { AutharizedEndPointService } from "@app/services/base-service/autharized-endpoint.service";
import { HttpClient } from '@angular/common/http';
import { AppSettings } from "@app/common/app-setting";
import { AccountInfoModel, AccountInfoModelList } from "@app/models/account-info/myAccountInfoModel";



@Injectable()
export class AccountInfoEndpoint extends AutharizedEndPointService {
    http1: HttpClient;
    _baseurl = `${AppSettings.API_ENDPOINT}`;

    private readonly _getMyAccountUrl: string = 'api/usermanagement/MyAccount/';
    private readonly _getGetCustomerCardDetailsUrl: string = 'api/UserManagement/GetCustomerCardDetails';
    private readonly _getGetAcquirerDetailsUrl: string = 'api/MerchantDashboardReport/GetDetailsForAcquirer';
    private readonly _getGetCustomerCardCustomerCardUrl: string = 'api/UserManagement/GetCustomerCardByCustomerCode/';
    private readonly _getDetailsMerchantUrl: string = 'api/MerchantDashboardReport/GetDetailsForMerchant/';
    private readonly _getProgramDetailsUrl: string = 'api/MerchantDashboardReport/GetProgramDetails';

    constructor(http: HttpClient) {
        super(http, 'UserManagement/Roles');
        this.http1 = http;
    }
    getUrl(url: string) {
        return this._baseurl + url;
    }

    getAccountInfo(IsDashboardCall) {
        debugger
        return this.http1.get<AccountInfoModel>
            (this.getUrl(this._getMyAccountUrl) + IsDashboardCall, this.AddAuthToken());
    }

    getCardNumber() {
        return this.http1.get(this.getUrl(this._getGetCustomerCardDetailsUrl), this.AddAuthToken());
    }

    getCustomerCardByCustomerCode(CustomerCode: string) {
        return this.http1.get<AccountInfoModel>(this.getUrl(this._getGetCustomerCardCustomerCardUrl) + CustomerCode, this.AddAuthToken());
    }
    
    getAcquirerDetails() {
        return this.http1.get(this.getUrl(this._getGetAcquirerDetailsUrl),this.AddAuthToken());
    }
    getDetailsMerchant(EntityId:number) {
        return this.http1.get(this.getUrl(this._getDetailsMerchantUrl)+EntityId,this.AddAuthToken());
    }
    getProgramDetails() {
        return this.http1.get(this.getUrl(this._getProgramDetailsUrl),this.AddAuthToken());
    }
}



// WEBPACK FOOTER //
// ./src/app/services/account-info/account-info-endpoint.service.ts